import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { t } from '@base/utils/helpers';
import { container } from 'tsyringe';
import GameMenuButtons, { MenuButton } from './gameMenuButtons';
import LobbyService from '@base/features/lobby/model/lobbyService';

export default function CloseTable(props: { closeModal: () => void }) {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const lobbyService: LobbyService = container.resolve('lobbyService');
  const gameState = playersOnlineRepository.me?.getTable()?.getGameState();
  const imPlaying = gameState && gameState.isGameInProgress() && gameState.imPlaying();

  const buttons: MenuButton[] = [
    {
      title: imPlaying ? t('close_forefeit') : t('yes'),
      onClick: () => lobbyService.leaveTable(),
    },
    {
      title: t('cancel'),
      onClick: () => props.closeModal(),
    },
  ];

  const message = imPlaying ? (
    <div>
      <h1>{t('warning')}</h1>
      {t('if_close_table_while_game_proceeding')}
    </div>
  ) : (
    t('sure_want_to_leave')
  );

  return (
    <>
      <p>{message}</p>
      <GameMenuButtons buttons={buttons} />
    </>
  );
}
